import Image from "next/image";

export default function Logo() {
  return <Image src="/logo.ico" alt="logo" width={256} height={256} />;
}
